import React from "react";
import { Check, Loader2 } from "lucide-react";

export const Chat8PerguntasPanelSuccessState: React.FC = React.memo(() => {
  return (
    <div
      id="chat8-perguntas-content"
      className="chat8-perguntas-content flex-1 flex items-center justify-center p-4"
      data-testid="chat8-perguntas-content"
    >
      <div className="flex flex-col items-center justify-center text-center max-w-md space-y-6">
        {/* Success Icon */}
        <div className="w-20 h-20 rounded-full bg-emerald-500/20 flex items-center justify-center animate-scale-in">
          <Check className="w-10 h-10 text-emerald-400" />
        </div>
        {/* Main Message */}
        <div className="space-y-2">
          <h3 className="text-xl font-bold text-platinum">
            Respostas Enviadas!
          </h3>
          <p className="text-silver/70 text-sm leading-relaxed">
            O assistente está processando suas respostas
          </p>
        </div>
        {/* Waiting Indicator */}
        <div className="flex flex-col items-center gap-4 w-full">
          <div className="flex items-center gap-3">
            <Loader2 className="w-4 h-4 text-blue-400 animate-spin" />
            <span className="text-sm text-silver/80 font-medium">
              Aguardando novas perguntas...
            </span>
          </div>
          {/* Progress Bar */}
          <div className="w-full h-1 bg-navy-700 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-blue-500 to-emerald-500 rounded-full animate-pulse" />
          </div>
        </div>
        {/* Informative Tip */}
        <div className="glass-card rounded-lg p-4 border border-white/10 w-full">
          <p className="text-xs text-silver/60 leading-relaxed">
            💡 O painel será atualizado automaticamente quando novas perguntas chegarem
          </p>
        </div>
      </div>
    </div>
  );
});

Chat8PerguntasPanelSuccessState.displayName = "Chat8PerguntasPanelSuccessState"; 